export enum Role {
  ADMINISTRADOR = 'ADMINISTRADOR',
  AUXILIAR_ADMINISTRATIVO = 'AUXILIAR ADMINISTRATIVO',
  FACTURACION = 'FACTURACION',
  AUXILIAR_LOGISTICO = 'AUXILIAR LOGISTICO',
  MENSAJERO = 'MENSAJERO',
  CLIENTE = 'CLIENTE'
}
